/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getContactSoftDeleteDocumentation } from '../fn/api-documentation-public/get-contact-soft-delete-documentation';
import { GetContactSoftDeleteDocumentation$Params } from '../fn/api-documentation-public/get-contact-soft-delete-documentation';
import { getContactSyncUpdateDocumentation } from '../fn/api-documentation-public/get-contact-sync-update-documentation';
import { GetContactSyncUpdateDocumentation$Params } from '../fn/api-documentation-public/get-contact-sync-update-documentation';


/**
 * Public API documentation endpoints
 */
@Injectable({ providedIn: 'root' })
export class ApiDocumentationPublicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getContactSyncUpdateDocumentation()` */
  static readonly GetContactSyncUpdateDocumentationPath = '/v1/api/ui/public/docs/contact-sync-update';

  /**
   * Get Contact Sync Update API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Sync Update API including authentication, integration flow, and usage examples.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactSyncUpdateDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSyncUpdateDocumentation$Response(params?: GetContactSyncUpdateDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getContactSyncUpdateDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Contact Sync Update API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Sync Update API including authentication, integration flow, and usage examples.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactSyncUpdateDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSyncUpdateDocumentation(params?: GetContactSyncUpdateDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getContactSyncUpdateDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getContactSoftDeleteDocumentation()` */
  static readonly GetContactSoftDeleteDocumentationPath = '/v1/api/ui/public/docs/contact-delete';

  /**
   * Get Contact Delete API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Delete API including authentication, batch deletion by phone number, and usage examples.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactSoftDeleteDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSoftDeleteDocumentation$Response(params?: GetContactSoftDeleteDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getContactSoftDeleteDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Contact Delete API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Delete API including authentication, batch deletion by phone number, and usage examples.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactSoftDeleteDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSoftDeleteDocumentation(params?: GetContactSoftDeleteDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getContactSoftDeleteDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
